import classes from "./NameDetailTemplate.module.css";
import { brand1 } from "../../constant";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TieredMenu } from "primereact/tieredmenu";
import { useRef } from "react";
import { Trash, Pencil } from "../../constant";
import clsx from "clsx";
const items = [
  {
    label: "Edit Profile",
    icon: <Pencil />,
  },
  {
    label: "Delete Corporate",
    icon: <Trash />,
  },
];
const NameDetailTemplate = ({ heading, description, logo, menuList   }) => {
  const menu = useRef(null);

  return (
    <>
      <div className={classes.wrapper}>
        <ol className={classes.header}>
          <li className={classes.nameWrapper}>
            <span className={classes.circleFrame}>
              <img src={logo} alt={"company logo"} className={clsx("img-fluid",classes.logo)} />
            </span>
            <div className={classes.detailContainer}>
              <h2>{heading}</h2>
              <p>{description}</p>
            </div>
          </li>
          <li className={classes.action}>
            {/* <span onClick={(e) => menu.current.toggle(e)}>
              <BsThreeDotsVertical size={20} />{" "}
            </span> */}
                {menuList}
          </li>
        </ol>
      </div>

    </>
  );
};
export default NameDetailTemplate;
